{ "bip122:12a765e31ffd4059bada1e25190f6e98/slip44:2": "litecoin" }
